/*
const state = () => ({
  mobile: "",
  registerAccessToken: "",
})

const mutations = {
  storePhoneNumber(state, payload) {
    state.mobile = payload
  },
  storeAccessToken(state, payload) {
    state.registerAccessToken = payload
  },
}


const register = {
  namespaced: true,
  state: state,
  mutations: mutations
};

export register;*/


export const register = {
  namespaced: true,
  state: {
    mobile: "",
    registerAccessToken: "",
  },
  mutations: {
    storePhoneNumber(state, payload) {
      state.mobile = payload
    },
    storeAccessToken(state, payload) {
      state.registerAccessToken = payload
    },
  },
};
